import * as angular from "angular";
import {IController} from "angular";

export class CustomOrderPlanningUploadsTableComponent implements IController {

  infiniteScroll: any;

  constructor() {
  }

}

angular
  .module('bringoz.admin.order-planning-configuration')
  .component('customOrderPlanningUploadsTable', {
    bindings: {
      infiniteScroll: '<?',
    },
    template: require('./custom-order-planning-uploads-table.html').default,
    controller: CustomOrderPlanningUploadsTableComponent
  });
